import type { Filters } from '@/types/mode-list-filters';

export class LocalStorageManager {
  private STORAGE_KEY = 'yb-filters';
  private isRoadbook = false;

  constructor() {
    // Antoine - 05/08/25 - fix temporaire pour le RB => pas de localstorage
    if (document.querySelector('yb-rdbk-list')) {
      this.isRoadbook = true;
    }
    // const isYoubookStorage = document.querySelector('yb-list');
    // isYoubookStorage ? this.STORAGE_KEY = 'yb-filters' : this.STORAGE_KEY = 'rdbk-filters';
  }

  load(): Filters | void {
    if (this.isRoadbook)
      return;
    const savedFilters = localStorage.getItem(this.STORAGE_KEY);
    if (!savedFilters)
      return;
    const parsedFilters = JSON.parse(savedFilters);
    const validTTS = (Date.now() - parsedFilters.tts) < (30 * 60 * 1000);
    if (validTTS) {
      return parsedFilters.data;
    }
    else {
      localStorage.removeItem(this.STORAGE_KEY);
    }
  }

  save(filters: Filters) {
    if (this.isRoadbook)
      return;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      data: filters,
      tts: Date.now(),
    }));
  }
}
